import { createSelector } from 'reselect';
import { RootState } from 'src/state/RootState';

export const getClients = createSelector([
    (state: RootState) => state.sdk.clients
], (clients) => clients
);
